package devxertech.com.pages.industries.devIndustryEdu.futureEdu

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span

@Composable
fun IndustryFuture() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()

    val spanModifier = Modifier
        .fontFamily(Constants.ROBOTO_FONT)
        .fontSize(if (breakpoint >= Breakpoint.LG) 34.px else 20.px)
        .fontWeight(FontWeight.ExtraBold)
        .lineHeight(if (breakpoint >= Breakpoint.LG) 37.4.px else 25.px)
        .letterSpacing(1.px)
        .textAlign(TextAlign.Center)
        .textTransform(TextTransform.Uppercase)
        .padding(bottom = if (breakpoint > Breakpoint.MD) 5.px else 0.px)

    Column(
        modifier = Modifier.fillMaxWidth()
            .margin(top = if (breakpoint > Breakpoint.MD) 20.px else 25.px)
            .padding(bottom = if (breakpoint > Breakpoint.XL) 0.px else 40.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
//            Row(
//                modifier = Modifier.margin(top = 30.px),
//                horizontalArrangement = Arrangement.Center,
//                verticalAlignment = Alignment.CenterVertically
//            ) {
                Span(attrs = Modifier.display(DisplayStyle.Flex)
                    .flexDirection(if (breakpoint <= Breakpoint.LG) FlexDirection.Column else FlexDirection.Row)
                    .fillMaxWidth()
                   .toAttrs()) {
                    SpanText(
                        text = "Shaping the Future of Education with ",
                        modifier = spanModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                    )
                    SpanText(
                        text = "Devxer Technology",
                        modifier = spanModifier.color(sitePalette.primary.rgb)
                    )
                }
//            }
        }
    }
        Row(modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center) {
        Image(
            description = "Education software overview",
                src = Res.Image.industry_shaping, modifier = Modifier.padding(topBottom = if (breakpoint < Breakpoint.MD) 0.px else 20.px)
                    .fillMaxWidth(if(window.screen.width > 475) 63.percent else 90.percent)

            )
        }
    Box(
        modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 20.px else 0.px),
        contentAlignment = Alignment.Center
    ){
        CommonButton(text = "Lets Talk", onClick = {}, linkPath = "/contact-us",
            letsTalkButton = true)
    }

}
